<template>
  <div
    :class="'switch-input-container ' + extraClass"
    v-on:click="$emit('click', $event.click)"
  >
    <i
      :class="switchClasses()"
      v-on:click="updateSwitchValue"
    />
    <input
      v-if="name"
      type="hidden"
      :value="getValue()"
      :name="name"
    />
  </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number, Boolean],
            default () {
                return false;
            }
        },
        disabled: {
            type: [String, Number, Boolean],
            default () {
                return false;
            }
        },
        iconSize: {
            type: [String, Number],
            default () {
                return 3;
            }
        },
        onValue: {
            type: [String, Number, Boolean],
            default () {
                return true;
            }
        },
        offValue: {
            type: [String, Number, Boolean],
            default () {
                return false;
            }
        },
        name: {
            type: String,
            default: ''
        },
        checked: {
            type: Boolean,
            default: false
        },
        extraClass: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            valueInput: this.value,
            disabledInput: Boolean(Number(this.disabled))

        };
    },
    methods: {
        switchClasses () {
            let isOn = this.valueInput == this.onValue,
                inputClass = {};

            inputClass['m--icon-font-size-lg' + this.iconSize] = true;
            inputClass['custom-toggle-on'] = isOn;
            inputClass['custom-toggle-off'] = !isOn;
            inputClass['disabled'] = this.disabledInput;
            inputClass['fas'] = true;
            return inputClass;
        },
        updateSwitchValue () {
            if (this.disabledInput) {
                return;
            }
            if (this.valueInput == this.onValue) {
                this.valueInput = this.offValue;
            } else {
                this.valueInput = this.onValue;
            }
            this.$emit('input', this.valueInput);
        },
        getValue () {
            return this.value == this.onValue ? 1 : 0;
        }
    },
    watch: {
        value (newValue) {
            this.valueInput = newValue;
        },
        disabled (newValue) {
            this.disabledInput = newValue;
        }
    }
};
</script>

<style scoped>
    .switch-input-container {
        height: 0px;
    }
    .vuetable-slot .switch-input-container {
        margin-top: -15px;
    }
</style>
